export default {
      id: "ig-usage",
      viewBox: "0 0 256 256",
      url: __webpack_public_path__ + "sprite.svg#ig-usage",
      toString: function () {
        return this.url;
      }
    }